import PropTypes from 'prop-types';
import React, { Component }  from 'react';
import defined from '~app/core/defined';
import { withT } from "~app/BundleProvider";

class GoogleDriveFileSelect extends Component {
  static propTypes = {
    fileList: PropTypes.array,
    handleSelect: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
  }

  state = {
    selected:null,
  }

  handleChange = (e) => {
    this.setState({selected: e.target.value});
  }

  handleSelect = () => {
    this.props.handleSelect(this.state.selected);
  }

  render() {
    const { t } = this.props;
    return (
      <div className="GoogleDriveFileSelect">
        <h1 className="GoogleDriveFileSelect__title">{t("select-project")}</h1>
        {/* eslint-disable */}
        <select onChange={this.handleChange} size={10} aria-label={t("project-list")}>
          <option style={{display:"none"}}></option>
          {this.props.fileList.map((file)=>(
            <option value={file.id} key={file.id}>{file.name}</option>
          ))}
        </select>
        {/* eslint-enable */}
        <div className="GoogleDriveFileSelect__button-group" >
          <button className="GoogleDriveFileSelect__button" onClick={this.handleSelect} disabled={!defined(this.state.selected)}>{t("ok")}</button>
          <button className="GoogleDriveFileSelect__button"  onClick={this.props.onCancel}>{t("cancel")}</button>
        </div>
      </div>
    );
  }
}

export default withT(GoogleDriveFileSelect);



// WEBPACK FOOTER //
// ./src/pages/Main/menu/GoogleDriveFileSelect.js